module.exports = __webpack_public_path__ + "static/viva_rewards-33dc01629882c1f386cbbe9535d189af.png";